/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ThemeInputs */

const th_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ธีม`)
};

const en_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme`)
};

const ja_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマ`)
};

const zh_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题`)
};

const es_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const pt_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const id_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const fr_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème`)
};

const tl_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const vi_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao diện`)
};

const ko_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테마`)
};

const de_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const ru_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема`)
};

const tr_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const it_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const pl_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motyw`)
};

const uk_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема`)
};

const hi_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`थीम`)
};

const ar_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المظهر`)
};

const ms_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema`)
};

const bn_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থিম`)
};

const zh_tw2_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`佈景主題`)
};

const zh_hk2_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主題`)
};

const ur_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تھیم`)
};

const fa_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوسته`)
};

const sw_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandhari`)
};

const nl_theme = /** @type {(inputs: ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema`)
};

/**
* | output |
* | --- |
* | "Theme" |
*
* @param {ThemeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const theme = /** @type {((inputs?: ThemeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ThemeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_theme(inputs)
	if (locale === "ja") return ja_theme(inputs)
	if (locale === "zh") return zh_theme(inputs)
	if (locale === "es") return es_theme(inputs)
	if (locale === "pt") return pt_theme(inputs)
	if (locale === "id") return id_theme(inputs)
	if (locale === "fr") return fr_theme(inputs)
	if (locale === "tl") return tl_theme(inputs)
	if (locale === "vi") return vi_theme(inputs)
	if (locale === "ko") return ko_theme(inputs)
	if (locale === "de") return de_theme(inputs)
	if (locale === "ru") return ru_theme(inputs)
	if (locale === "tr") return tr_theme(inputs)
	if (locale === "it") return it_theme(inputs)
	if (locale === "pl") return pl_theme(inputs)
	if (locale === "uk") return uk_theme(inputs)
	if (locale === "hi") return hi_theme(inputs)
	if (locale === "ar") return ar_theme(inputs)
	if (locale === "ms") return ms_theme(inputs)
	if (locale === "bn") return bn_theme(inputs)
	if (locale === "zh-TW") return zh_tw2_theme(inputs)
	if (locale === "zh-HK") return zh_hk2_theme(inputs)
	if (locale === "ur") return ur_theme(inputs)
	if (locale === "fa") return fa_theme(inputs)
	if (locale === "sw") return sw_theme(inputs)
	if (locale === "nl") return nl_theme(inputs)
	return en_theme(inputs)
});